import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  Typography,
  Button,
  Stack,
  useTheme
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import MKButton from "./MKButton";
import MKTypography from "./MKTypography";
import { PRIMARY_PINK, TRANSPARENT_BLACK_50 } from "../constants";

function CookieConsentBanner() {
  const theme = useTheme();
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already given consent
    const consentGiven = localStorage.getItem('cookieConsent');
    if (!consentGiven) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        p: 2,
        backgroundColor: TRANSPARENT_BLACK_50,
        backdropFilter: 'blur(10px)'
      }}
    >
      <Paper
        sx={{
          maxWidth: 600,
          mx: 'auto',
          p: 3,
          borderRadius: 2,
          backgroundColor: theme.palette.mode === 'dark' ? '#1e1e1e' : '#ffffff',
          border: `1px solid ${theme.palette.mode === 'dark' ? '#404040' : '#e0e0e0'}`
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
          <MKTypography
            variant="h6"
            fontWeight="bold"
            sx={{ color: PRIMARY_PINK, flex: 1 }}
          >
            Cookie Consent
          </MKTypography>
          <Button
            onClick={handleDecline}
            sx={{
              minWidth: 'auto',
              p: 0.5,
              color: 'text.secondary',
              '&:hover': {
                backgroundColor: 'transparent',
                color: 'text.primary'
              }
            }}
            aria-label="Close cookie consent banner"
          >
            <CloseIcon fontSize="small" />
          </Button>
        </Box>

        <MKTypography variant="body2" color="text.secondary" mb={3}>
          We use cookies to enhance your experience on our website. By continuing to use our site, you consent to our use of cookies. 
          You can learn more about our cookie usage in our{" "}
          <MKTypography
            component="a"
            href="/privacy-policy"
            sx={{
              color: PRIMARY_PINK,
              textDecoration: 'none',
              '&:hover': {
                textDecoration: 'underline'
              }
            }}
          >
            Privacy Policy
          </MKTypography>
          .
        </MKTypography>

        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="flex-end">
          <MKButton
            variant="outlined"
            size="small"
            onClick={handleDecline}
            sx={{
              borderColor: theme.palette.mode === 'dark' ? '#404040' : '#e0e0e0',
              color: 'text.primary',
              '&:hover': {
                borderColor: PRIMARY_PINK,
                color: PRIMARY_PINK
              }
            }}
          >
            Decline
          </MKButton>
          <MKButton
            variant="contained"
            size="small"
            onClick={handleAccept}
            sx={{
              backgroundColor: PRIMARY_PINK,
              color: 'white',
              '&:hover': {
                backgroundColor: '#c2185b'
              }
            }}
          >
            Accept
          </MKButton>
        </Stack>
      </Paper>
    </Box>
  );
}

export default CookieConsentBanner;
